// apps/client/src/ui/kit/Toast.tsx — toasts stack below the HUD row on the right, under the reconnect banner while it shows (tokens.css)
import { t } from '@whiskerton/content';
import { useEffect } from 'react';
import { useGame } from '../../state/store';
const TOAST_MS = 3500;
export function Toasts() {
  const toasts = useGame((s) => s.toasts);
  const dismiss = useGame((s) => s.dismissToast);
  const banner = useGame((s) => s.banner === 'reconnecting' && s.phase === 'inTown');
  useEffect(() => {
    // Each toast stays TOAST_MS after it was shown or last refreshed (core.ts `toast` refreshes an identical one in place).
    const now = Date.now();
    const timers = toasts.map((x) => setTimeout(() => dismiss(x.id), Math.max(0, (x.at ?? now) + TOAST_MS - now)));
    return () => timers.forEach(clearTimeout);
  }, [toasts, dismiss]);
  return <div className={`toasts${banner ? ' under-banner' : ''}`} role="status">{toasts.map((x) => <div key={x.id} className={`toast toast-${x.tone}`}>{t(x.key, x.params)}</div>)}</div>;
}
